import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  successData: null,
  marginList: [],
  marginTotal: 0,
};

const bullionSlice = createSlice({
  name: "bullion",
  initialState,
  reducers: {
    getBullionRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.successData = null;
    },
    getBullionSuccess: (state, action) => {
      state.loading = false;
      state.successData = action.payload;
    },
    getBullionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateBullionTaxRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateBullionTaxSuccess: (state, action) => {
      state.loading = false;
      state.successData = action.payload;
    },
    updateBullionTaxFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearBullionState: (state) => {
      state.loading = false;
      state.error = null;
      state.successData = null;
    },
    getBullionMarginsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getBullionMarginsSuccess: (state, action) => {
      state.loading = false;
      state.marginList = action.payload?.contents || [];
      state.marginTotal = action.payload?.total || 0;
    },
    getBullionMarginsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getBullionRequest,
  getBullionSuccess,
  getBullionFailure,
  clearBullionState,
  updateBullionTaxRequest,
  updateBullionTaxSuccess,
  updateBullionTaxFailure,
  getBullionMarginsRequest,
  getBullionMarginsSuccess,
  getBullionMarginsFailure,
} = bullionSlice.actions;

export default bullionSlice.reducer;
